// Module
var code = "<tmr-nav-bar items=\"::[\n{ state: 'app.report.propellantZone.list', title: 'REPORT.PROPELLANT.MENUBAR.ZONE' },\n{ state: 'app.report.propellantPlace.list', title: 'REPORT.PROPELLANT.MENUBAR.PLACE' }\n]\"></tmr-nav-bar> ";
// Exports
var _module_exports =code;;
var path = 'components/navBar/propellantNavBar/propellantNavBar.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;